import { render, staticRenderFns } from "./AvatarDropdown.vue?vue&type=template&id=74689182&scoped=true"
import script from "./AvatarDropdown.vue?vue&type=script&lang=js"
export * from "./AvatarDropdown.vue?vue&type=script&lang=js"
import style0 from "./AvatarDropdown.vue?vue&type=style&index=0&id=74689182&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74689182",
  null
  
)

export default component.exports